const PARAMS = "params";
const DATA = "data";
const RESOLVE = "resolve";
const REJECT = "reject";

export { PARAMS, DATA, RESOLVE, REJECT };
